import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Social.css';

class Social extends Component {
  render() {
    const aboutImg = require('./assets/about.svg');
    const igImg = require('./assets/github.svg');
    const githubImg = require('./assets/ig.svg');
    return (
      <>
        <div className='social'>
          <Link to='/about'>
            <img src={aboutImg} className='social-img' alt='About' />
          </Link>
          <a href='https://www.instagram.com/maps_affinity/'>
            <img src={igImg} className='social-img' alt='Instagram' />
          </a>
          <a href='https://github.com/Deep-Codes'>
            <img src={githubImg} className='social-img' alt='Github' />
          </a>
        </div>
        <div className='copyright'>&#169; Deepankar Bhade 2020</div>
      </>
    );
  }
}

export default Social;
